import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataReport(params) {
	return client.get("api/report/data", {
		params: params,
	});
}

function getDataReportSummaryProvince(params) {
	return client.get("api/report/data_summary_province", {
		params: params,
	});
}

function getDataReportSummaryWarehouse(params) {
	return client.get("api/report/data_summary_warehouse", {
		params: params,
	});
}

function getDataSummarySerialDigital() {
	return client.get("api/report/summary_serial_digital");
}

export default {
	getDataReport,
	getDataReportSummaryProvince,
	getDataReportSummaryWarehouse,
	getDataSummarySerialDigital
};